import { createQueryKeys } from "@lukemorales/query-key-factory";
import api from "utils/api";

import { endpoints } from "utils/endpoints";
import { PostModel } from "common/models/BaseModel";
import { IListResponse } from "common/models/GridModels";
import { fineView } from "../types/fineView";
import {
  IFine,
  IFineGridFilter,
  IFineGridModel,
  MemberFineListResult,
  IFineCollectionListGridPostModel,
  IFineReportsFilter,
  FineReportsCount,
} from "./types";

export const fine = createQueryKeys("fine", {
  list: (postModel: PostModel<IFineGridFilter>) => ({
    queryKey: [postModel],
    queryFn: () =>
      api.post<IListResponse<IFineGridModel>>(endpoints.fine.list, postModel),
  }),

  getById: (Id: string | number) => ({
    queryKey: [Id],
    queryFn: () => api.get<IFine>(`${endpoints.fine.getById}/${Id}`),
  }),

  getViewById: (Id: string | number) => ({
    queryKey: ["modal", Id],
    queryFn: () => api.get<fineView>(`${endpoints.fine.view}/${Id}`),
  }),

  getFinelist: (model: IFineCollectionListGridPostModel) => ({
    queryKey: ["memberFinelist"],
    queryFn: () =>
      api.post<IListResponse<MemberFineListResult>>(
        endpoints.fine.getFinelist,
        model
      ),
  }),

  reportsCount: (postModel: IFineReportsFilter) => ({
    queryKey: [postModel],
    queryFn: () => api.post<FineReportsCount>(endpoints.fine.reportsCount, postModel),
  }),
});
